module.exports = __webpack_public_path__ + "static/media/linkedin.bd57db67.svg";